/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 08 2024
 **/

import { Button, Typography } from "@/frameworks/designStuff/components";
import { _P, _T } from "@rfice/language";
import { useBlock } from "@/frameworks/core/API";

import * as S from "./emotion";

export default function OneOnOneBlock({ blockedUser }: { blockedUser: Users.People.Data }) {
	const blockAPI = useBlock();

	return (
		<>
			<S.DisabledDimmed />
			<S.BlockInformationWrapper>
				<Typography>
					{_P("차단된 {{name}} 님과 더이상 메시지를 주고받을 수 없습니다. 차단해제 후 확인해주세요.", {
						name: blockedUser?.name
					})}
				</Typography>
				<Button
					css={{ alignSelf: "flex-end" }}
					onClick={() => {
						blockAPI.release.execute({ userId: blockedUser?.id });
					}}
				>
					{_T("차단 해제")}
				</Button>
			</S.BlockInformationWrapper>
		</>
	);
}
